// import { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { Save, Plus, Trash2, Lock, CreditCard, FileText, Users, ArrowLeft } from "lucide-react";
// import { toast } from "react-toastify";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";
// import SelectDropdown from "../../customStyles/SelectDropdown";
// import CustomDatePicker from "../../customStyles/CustomDatePicker";

// const PAY_FREQ = [
//   { id: "monthly", label: "Monthly" },
//   { id: "biweekly", label: "Bi-Weekly" },
//   { id: "weekly", label: "Weekly" },
// ];

// const RELATIONSHIP_OPTIONS = [
//   { id: "spouse", label: "Spouse" },
//   { id: "child", label: "Child" },
//   { id: "parent", label: "Parent" },
//   { id: "sibling", label: "Sibling" },
//   { id: "other", label: "Other" },
// ];

// const blankNominee = () => ({ name: "", relationship: "", dob: null, sharePercent: "" });

// const Field = ({ label, children, error }) => (
//   <div>
//     <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
//     {children}
//     {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
//   </div>
// );

// const inp = (val, onChange, placeholder, type = "text") => (
//   <input
//     type={type}
//     value={val}
//     onChange={(e) => onChange(e.target.value)}
//     placeholder={placeholder}
//     className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none outline-none focus:ring-2 focus:ring-red-400"
//   />
// );

// const Section = ({ icon: Icon, title, color = "blue", children }) => (
//   <div className="bg-white rounded-xl overflow-hidden">
//     <div className={`flex items-center gap-2 px-5 py-3 bg-${color}-50 border-b border-gray-100`}>
//       <Icon className={`w-4 h-4 text-${color}-600`} />
//       <h3 className="font-semibold text-gray-800 text-sm">{title}</h3>
//     </div>
//     <div className="p-5">{children}</div>
//   </div>
// );

// // ════════════════════════════════════════════════════════════════
// const EmployeeFinanceForm = () => {
//   const { employeeId } = useParams();
//   const navigate = useNavigate();

//   const [data, setData] = useState({
//     panNumber: "", aadhaarNumber: "", uanNumber: "", esiNumber: "", pfAccountNumber: "",
//     bankDetails: { accountHolderName: "", accountNumber: "", ifscCode: "", bankName: "", branchName: "" },
//     nominees: [],
//     payFrequency: "monthly",
//   });
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [employee, setEmployee] = useState(null);
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const [empRes, finRes] = await Promise.all([
//           api.get(SummaryApi.getOneEmployee?.url(employeeId) || `/api/employees/${employeeId}`),
//           api.get(SummaryApi.getOneEmployeeFinance?.url(employeeId) || `/api/employees/${employeeId}/finance`).catch(() => ({ data: { data: null } })),
//         ]);
//         setEmployee(empRes.data.data);
//         if (finRes.data.data) {
//           const f = finRes.data.data;
//           setData({
//             panNumber: f.panNumber || "",
//             aadhaarNumber: f.aadhaarNumber || "",
//             uanNumber: f.uanNumber || "",
//             esiNumber: f.esiNumber || "",
//             pfAccountNumber: f.pfAccountNumber || "",
//             bankDetails: {
//               accountHolderName: f.bankDetails?.accountHolderName || "",
//               accountNumber: f.bankDetails?.accountNumber || "",
//               ifscCode: f.bankDetails?.ifscCode || "",
//               bankName: f.bankDetails?.bankName || "",
//               branchName: f.bankDetails?.branchName || "",
//             },
//             nominees: (f.nominees || []).map((n) => ({ ...n, dob: n.dob || null, sharePercent: n.sharePercent ?? "" })),
//             payFrequency: f.payFrequency || "monthly",
//           });
//         }
//       } catch {
//         toast.error("Failed to load finance data");
//       } finally {
//         setLoading(false);
//       }
//     };
//     load();
//   }, [employeeId]);

//   const set = (key, val) => setData((p) => ({ ...p, [key]: val }));
//   const setBank = (key, val) => setData((p) => ({ ...p, bankDetails: { ...p.bankDetails, [key]: val } }));
//   const setNominee = (i, key, val) => {
//     const arr = [...data.nominees];
//     arr[i] = { ...arr[i], [key]: val };
//     set("nominees", arr);
//   };

//   const totalShare = data.nominees.reduce((sum, n) => sum + (Number(n.sharePercent) || 0), 0);

//   const validate = () => {
//     const errs = {};
//     if (data.nominees.length > 0 && totalShare !== 100) {
//       errs.nominees = `Nominee shares must total 100% (currently ${totalShare}%)`;
//     }
//     data.nominees.forEach((n, i) => {
//       if (!n.name.trim()) errs[`nom_${i}_name`] = "Required";
//     });
//     setErrors(errs);
//     return Object.keys(errs).length === 0;
//   };

//     const handleSave = async () => {
//     if (!validate()) { toast.error("Please fix errors before saving"); return; }
//     setSaving(true);
//     try {
//         await api.put(SummaryApi.saveOneEmployeeFinance?.url(employeeId), data); 
        
//         toast.success("Finance record saved successfully");
//     } catch (err) {
//         toast.error(err.response?.data?.message || "Save failed");
//     } finally {
//         setSaving(false);
//     }
//     };

//   if (loading) return <PageLoader />;

//   return (
//     <div className="p-2">
//       {/* Header */}
//       <div className="flex items-center justify-between mb-5">
//         <div className="flex items-center gap-3">
//         <button type="button" onClick={() => navigate(-1)}
//           className="p-2 rounded-lg bg-red-50 border border-red-100 hover:border-primary text-textPrimary hover:text-primary transition-colors">
//           <ArrowLeft className="w-5 h-5" />
//         </button>
//           <div>
//             <h1 className="text-lg font-bold text-gray-900">Finance & Statutory Details</h1>
//             {employee && (
//               <p className="text-sm text-gray-500">{employee.firstName} {employee.lastName} · {employee.userId}</p>
//             )}
//           </div>
//         </div>
//         <div className="flex items-center gap-1.5 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5">
//           <Lock className="w-3 h-3" /> Restricted access
//         </div>
//       </div>

//       <div className="space-y-4">
//         {/* Govt IDs */}
//         <Section icon={FileText} title="Government & Statutory IDs" color="blue">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             <Field label="PAN Number">{inp(data.panNumber, (v) => set("panNumber", v.toUpperCase()), "e.g. ABCDE1234F")}</Field>
//             <Field label="Aadhaar Number">{inp(data.aadhaarNumber, (v) => set("aadhaarNumber", v.replace(/\D/g, "").slice(0, 12)), "12-digit Aadhaar", "tel")}</Field>
//             <Field label="UAN Number (EPF)">{inp(data.uanNumber, (v) => set("uanNumber", v), "Universal Account Number")}</Field>
//             <Field label="ESIC Number">{inp(data.esiNumber, (v) => set("esiNumber", v), "ESIC Member Number")}</Field>
//             <Field label="PF Account Number (if different from UAN)">{inp(data.pfAccountNumber, (v) => set("pfAccountNumber", v), "Org PF Account No.")}</Field>
//             <Field label="Pay Frequency">
//               <SelectDropdown options={PAY_FREQ} value={data.payFrequency} onChange={(v) => set("payFrequency", v)} valueKey="id" labelKey="label" />
//             </Field>
//           </div>
//         </Section>

//         {/* Bank Details */}
//         <Section icon={CreditCard} title="Bank Account Details" color="green">
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             <Field label="Account Holder Name">
//               {inp(data.bankDetails.accountHolderName, (v) => setBank("accountHolderName", v), "As per bank records")}
//             </Field>
//             <Field label="Account Number">
//               {inp(data.bankDetails.accountNumber, (v) => setBank("accountNumber", v), "Account number", "tel")}
//             </Field>
//             <Field label="IFSC Code">
//               {inp(data.bankDetails.ifscCode, (v) => setBank("ifscCode", v.toUpperCase()), "e.g. SBIN0001234")}
//             </Field>
//             <Field label="Bank Name">
//               {inp(data.bankDetails.bankName, (v) => setBank("bankName", v), "e.g. State Bank of India")}
//             </Field>
//             <Field label="Branch Name" >
//               {inp(data.bankDetails.branchName, (v) => setBank("branchName", v), "e.g. Anna Nagar Branch")}
//             </Field>
//           </div>
//         </Section>

//         {/* Nominees */}
//         <Section icon={Users} title="PF / Gratuity Nominees" color="purple">
//           {errors.nominees && (
//             <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
//               {errors.nominees}
//             </div>
//           )}

//           {data.nominees.length === 0 && (
//             <p className="text-sm text-gray-400 mb-3">No nominees added. Add at least one for EPF compliance.</p>
//           )}

//           <div className="space-y-3">
//             {data.nominees.map((n, i) => (
//               <div key={i} className="border rounded-lg p-4 bg-gray-50 relative">
//                 <button
//                   type="button"
//                   onClick={() => set("nominees", data.nominees.filter((_, idx) => idx !== i))}
//                   className="absolute top-3 right-3 text-red-500 hover:text-red-700"
//                 >
//                   <Trash2 className="w-4 h-4" />
//                 </button>
//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pr-6">
//                   <Field label="Name" error={errors[`nom_${i}_name`]}>
//                     <input
//                       type="text"
//                       value={n.name}
//                       onChange={(e) => setNominee(i, "name", e.target.value)}
//                       placeholder="Full name"
//                       className={`w-full border rounded-lg px-3 py-2 text-sm focus:outline-none outline-none focus:ring-2 focus:ring-red-400 ${errors[`nom_${i}_name`] ? "border-red-500" : "border-gray-300"}`}
//                     />
//                   </Field>
//                   <Field label="Relationship">
//                     <SelectDropdown
//                       options={RELATIONSHIP_OPTIONS}
//                       value={n.relationship}
//                       onChange={(v) => setNominee(i, "relationship", v)}
//                       placeholder="Select relationship"
//                       valueKey="id"
//                       labelKey="label"
//                     />
//                   </Field>
//                   <Field label="Date of Birth">
//                     <CustomDatePicker
//                       value={n.dob}
//                       onChange={(d) => setNominee(i, "dob", d)}
//                       placeholder="Nominee DOB"
//                       maxDate={new Date()}
//                     />
//                   </Field>
//                   <Field label="Share %">
//                     <input
//                       type="number"
//                       min={0}
//                       max={100}
//                       value={n.sharePercent}
//                       onChange={(e) => setNominee(i, "sharePercent", e.target.value)}
//                       placeholder="e.g. 50"
//                       className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none outline-none focus:ring-2 focus:ring-red-400"
//                     />
//                   </Field>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="flex items-center justify-between mt-3">
//             <button
//               type="button"
//               onClick={() => set("nominees", [...data.nominees, blankNominee()])}
//               className="flex items-center gap-1.5 text-purple-600 hover:text-purple-800 text-sm font-medium"
//             >
//               <Plus className="w-4 h-4" /> Add Nominee
//             </button>
//             {data.nominees.length > 0 && (
//               <span className={`text-xs font-medium px-2 py-1 rounded ${totalShare === 100 ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
//                 Total: {totalShare}% {totalShare === 100 ? "✓" : `(need ${100 - totalShare}% more)`}
//               </span>
//             )}
//           </div>
//         </Section>
//       </div>

//       {/* Footer */}
//       <div className="flex gap-3 mt-5 pb-6">
//         <button onClick={() => navigate(-1)} className="flex-1 border rounded-lg py-2.5 hover:bg-gray-50 text-sm font-medium">
//           Cancel
//         </button>
//         <button
//           onClick={handleSave}
//           disabled={saving}
//           className="flex-1 bg-gradient-to-r from-blue-600 to-purple-600 disabled:opacity-50 text-white rounded-lg py-2.5 flex items-center justify-center gap-2 text-sm font-medium hover:opacity-90"
//         >
//           <Save className="w-4 h-4" /> {saving ? "Saving..." : "Save Finance Details"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default EmployeeFinanceForm;
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Save, Plus, Trash2, Lock, CreditCard, FileText, Users, ArrowLeft } from "lucide-react";
import { toast } from "react-toastify";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import CustomDatePicker from "../../customStyles/CustomDatePicker";

const PAY_FREQ = [
  { id: "monthly", label: "Monthly" },
  // { id: "biweekly", label: "Bi-Weekly" },
  // { id: "weekly", label: "Weekly" },
];

const RELATIONSHIP_OPTIONS = [
  { id: "spouse", label: "Spouse" },
  { id: "child", label: "Child" },
  { id: "parent", label: "Parent" },
  { id: "sibling", label: "Sibling" },
  { id: "other", label: "Other" },
];

const blankNominee = () => ({ name: "", relationship: "", dob: null, sharePercent: "" });

// கட்டாயமாகத் தேவைப்படும் இடங்களுக்கு * குறியீடு சேர்க்கப்பட்டுள்ளது
const Field = ({ label, children, error, required }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-[11px] mt-1">{error}</p>}
  </div>
);

// இன்புட் ஸ்டைல் எரர் இருக்கும்போது சிவப்பாக மாறும்
const inp = (val, onChange, placeholder, hasError, type = "text") => (
  <input
    type={type}
    value={val}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    className={`w-full border rounded-lg px-3 py-2 text-sm focus:outline-none outline-none focus:ring-2 focus:ring-red-400 transition-all ${
      hasError ? "border-red-500 bg-red-50" : "border-gray-300"
    }`}
  />
);

// டிராப்டவுன் மறையாமல் இருக்க overflow-hidden நீக்கப்பட்டுள்ளது
const Section = ({ icon: Icon, title, color = "blue", children }) => (
  <div className="bg-white rounded-xl border border-gray-100 shadow-sm mb-4 relative z-auto">
    <div className={`flex items-center gap-2 px-5 py-3 bg-${color}-50 border-b border-gray-100 rounded-t-xl`}>
      <Icon className={`w-4 h-4 text-${color}-600`} />
      <h3 className="font-semibold text-gray-800 text-sm">{title}</h3>
    </div>
    <div className="p-5">{children}</div>
  </div>
);

const EmployeeFinanceForm = () => {
  const { employeeId } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState({
    panNumber: "", aadhaarNumber: "", uanNumber: "", esiNumber: "", pfAccountNumber: "",
    bankDetails: { accountHolderName: "", accountNumber: "", ifscCode: "", bankName: "", branchName: "" },
    nominees: [],
    payFrequency: "monthly",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const load = async () => {
      try {
        const [empRes, finRes] = await Promise.all([
          api.get(SummaryApi.getOneEmployee?.url(employeeId) || `/api/employees/${employeeId}`),
          api.get(SummaryApi.getOneEmployeeFinance?.url(employeeId) || `/api/employees/${employeeId}/finance`).catch(() => ({ data: { data: null } })),
        ]);
        setEmployee(empRes.data.data);
        if (finRes.data.data) {
          const f = finRes.data.data;
          setData({
            panNumber: f.panNumber || "",
            aadhaarNumber: f.aadhaarNumber || "",
            uanNumber: f.uanNumber || "",
            esiNumber: f.esiNumber || "",
            pfAccountNumber: f.pfAccountNumber || "",
            bankDetails: {
              accountHolderName: f.bankDetails?.accountHolderName || "",
              accountNumber: f.bankDetails?.accountNumber || "",
              ifscCode: f.bankDetails?.ifscCode || "",
              bankName: f.bankDetails?.bankName || "",
              branchName: f.bankDetails?.branchName || "",
            },
            nominees: (f.nominees || []).map((n) => ({ ...n, dob: n.dob || null, sharePercent: n.sharePercent ?? "" })),
            payFrequency: f.payFrequency || "monthly",
          });
        }
      } catch {
        toast.error("Failed to load finance data");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [employeeId]);

  const set = (key, val) => {
    setData((p) => ({ ...p, [key]: val }));
    if (errors[key]) setErrors(prev => ({ ...prev, [key]: null }));
  };

  const setBank = (key, val) => {
    setData((p) => ({ ...p, bankDetails: { ...p.bankDetails, [key]: val } }));
    if (errors[`bank_${key}`]) setErrors(prev => ({ ...prev, [`bank_${key}`]: null }));
  };

  const setNominee = (i, key, val) => {
    const arr = [...data.nominees];
    arr[i] = { ...arr[i], [key]: val };
    set("nominees", arr);
  };

  const totalShare = data.nominees.reduce((sum, n) => sum + (Number(n.sharePercent) || 0), 0);

  // வலுவான வேலிடேஷன் லாஜிக்
  const validate = () => {
    const errs = {};
    
    // Govt IDs
    if (!data.panNumber) errs.panNumber = "PAN Number is required";
    if (!data.aadhaarNumber) errs.aadhaarNumber = "Aadhaar Number is required";
    else if (data.aadhaarNumber.length !== 12) errs.aadhaarNumber = "Must be 12 digits";
    // if (!data.uanNumber) errs.uanNumber = "UAN Number is required";

    // Bank Details
    if (!data.bankDetails.accountHolderName) errs.bank_accountHolderName = "Required";
    if (!data.bankDetails.accountNumber) errs.bank_accountNumber = "Required";
    if (!data.bankDetails.ifscCode) errs.bank_ifscCode = "Required";
    if (!data.bankDetails.bankName) errs.bank_bankName = "Required";

    // Nominees
    if (data.nominees.length > 0) {
      if (totalShare !== 100) errs.nominee_total = `Total share must be 100% (Current: ${totalShare}%)`;
      data.nominees.forEach((n, i) => {
        if (!n.name.trim()) errs[`nom_${i}_name`] = "Name required";
        if (!n.sharePercent) errs[`nom_${i}_share`] = "Share % required";
      });
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) { 
      toast.error("Please fill all required fields correctly"); 
      return; 
    }
    setSaving(true);
    try {
      await api.put(SummaryApi.saveOneEmployeeFinance?.url(employeeId), data); 
      toast.success("Finance record saved successfully");
    } catch (err) {
      toast.error(err.response?.data?.message || "Save failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <PageLoader />;

  return (
    <div className="p-2">
      {/* Header */}
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-3">
          <button type="button" onClick={() => navigate(-1)}
            className="p-2 rounded-lg bg-red-50 border border-red-100 hover:border-red-500 text-gray-700 hover:text-red-600 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-lg font-bold text-gray-900">Finance & Statutory Details</h1>
            {employee && (
              <p className="text-sm text-gray-500">{employee.firstName} {employee.lastName} · {employee.userId}</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-3 py-1.5">
          <Lock className="w-3 h-3" /> Restricted access
        </div>
      </div>

      <div className="space-y-4">
        {/* Govt IDs */}
        <Section icon={FileText} title="Government & Statutory IDs" color="blue">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <Field label="PAN Number" required error={errors.panNumber}>
              {inp(data.panNumber, (v) => set("panNumber", v.toUpperCase()), "ABCDE1234F", errors.panNumber)}
            </Field>
            <Field label="Aadhaar Number" required error={errors.aadhaarNumber}>
              {inp(data.aadhaarNumber, (v) => set("aadhaarNumber", v.replace(/\D/g, "").slice(0, 12)), "12-digit number", errors.aadhaarNumber, "tel")}
            </Field>
            <Field label="UAN Number (EPF)" required error={errors.uanNumber}>
              {inp(data.uanNumber, (v) => set("uanNumber", v), "Universal Account Number", errors.uanNumber)}
            </Field>
            <Field label="ESIC Number">{inp(data.esiNumber, (v) => set("esiNumber", v), "Member Number")}</Field>
            <Field label="PF Account Number">{inp(data.pfAccountNumber, (v) => set("pfAccountNumber", v), "Org Specific No.")}</Field>
            <Field label="Pay Frequency" required>
              <div className="relative z-20">
                <SelectDropdown options={PAY_FREQ} value={data.payFrequency} onChange={(v) => set("payFrequency", v)} valueKey="id" labelKey="label" />
              </div>
            </Field>
          </div>
        </Section>

        {/* Bank Details */}
        <Section icon={CreditCard} title="Bank Account Details" color="green">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <Field label="Account Holder Name" required error={errors.bank_accountHolderName}>
              {inp(data.bankDetails.accountHolderName, (v) => setBank("accountHolderName", v), "As per bank", errors.bank_accountHolderName)}
            </Field>
            <Field label="Account Number" required error={errors.bank_accountNumber}>
              {inp(data.bankDetails.accountNumber, (v) => setBank("accountNumber", v), "Bank account no.", errors.bank_accountNumber, "tel")}
            </Field>
            <Field label="IFSC Code" required error={errors.bank_ifscCode}>
              {inp(data.bankDetails.ifscCode, (v) => setBank("ifscCode", v.toUpperCase()), "e.g. SBIN0001234", errors.bank_ifscCode)}
            </Field>
            <Field label="Bank Name" required error={errors.bank_bankName}>
              {inp(data.bankDetails.bankName, (v) => setBank("bankName", v), "e.g. HDFC Bank", errors.bank_bankName)}
            </Field>
            <Field label="Branch Name">
              {inp(data.bankDetails.branchName, (v) => setBank("branchName", v), "e.g. Main Branch")}
            </Field>
          </div>
        </Section>

        {/* Nominees */}
        <Section icon={Users} title="PF / Gratuity Nominees" color="purple">
          {errors.nominee_total && (
            <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-xs text-red-700 font-medium">
              {errors.nominee_total}
            </div>
          )}

          <div className="space-y-3">
            {data.nominees.map((n, i) => (
              <div key={i} className="border rounded-lg p-4 bg-gray-50/50 relative">
                <button
                  type="button"
                  onClick={() => set("nominees", data.nominees.filter((_, idx) => idx !== i))}
                  className="absolute top-3 right-3 text-red-400 hover:text-red-600 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 pr-6">
                  <Field label="Name" required error={errors[`nom_${i}_name`]}>
                    {inp(n.name, (v) => setNominee(i, "name", v), "Full name", errors[`nom_${i}_name`])}
                  </Field>
                  <Field label="Relationship" required>
                    <SelectDropdown options={RELATIONSHIP_OPTIONS} value={n.relationship} onChange={(v) => setNominee(i, "relationship", v)} valueKey="id" labelKey="label" />
                  </Field>
                  <Field label="DOB">
                    <CustomDatePicker value={n.dob} onChange={(d) => setNominee(i, "dob", d)} maxDate={new Date()} />
                  </Field>
                  <Field label="Share %" required error={errors[`nom_${i}_share`]}>
                    {inp(n.sharePercent, (v) => setNominee(i, "sharePercent", v), "e.g. 100", errors[`nom_${i}_share`], "number")}
                  </Field>
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center justify-between mt-4">
            <button
              type="button"
              onClick={() => set("nominees", [...data.nominees, blankNominee()])}
              className="flex items-center gap-1.5 text-purple-600 hover:text-purple-800 text-sm font-semibold transition-colors"
            >
              <Plus className="w-4 h-4" /> Add Nominee
            </button>
            {data.nominees.length > 0 && (
              <span className={`text-xs font-bold px-3 py-1 rounded-full ${totalShare === 100 ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>
                Allocated: {totalShare}% {totalShare === 100 ? "✓" : `(Pending: ${100 - totalShare}%)`}
              </span>
            )}
          </div>
        </Section>
      </div>

      {/* Footer */}
      <div className="flex gap-4 mt-6 pb-10">
        <button onClick={() => navigate(-1)} className="flex-1 border-2 border-gray-100 rounded-xl py-3 hover:bg-gray-50 text-sm font-bold text-gray-600 transition-colors">
          Discard Changes
        </button>
        <button
          onClick={handleSave}
          disabled={saving}
          className="flex-1 bg-gray-900 disabled:bg-gray-400 text-white rounded-xl py-3 flex items-center justify-center gap-2 text-sm font-bold hover:bg-black transition-all shadow-lg active:scale-[0.98]"
        >
          <Save className="w-4 h-4" /> {saving ? "Saving Data..." : "Save Finance Details"}
        </button>
      </div>
    </div>
  );
};

export default EmployeeFinanceForm;